import { ExportOptions } from './model';

export class SetExportOptions {
  static readonly type = '[ExportOptions] Set values';
  constructor(
    public page: string,
    public options: ExportOptions,
  ) { }
}
